export enum DeviceInstallationStatus
{
    NotInstalled = 0,
    Installed = 1,
    CantBeInstalled = 2,
    NotApplicable = 3
}

export namespace DeviceInstallationStatus
{
    export const toString = ( value: DeviceInstallationStatus ) => 
    {
        const labels = [
            "Not Installed",
            "Installed",
            "Can't Be Installed",
            "Not Applicable"
        ];
        return labels[ value ];
    };
}